<template>
    <div>
        <div class="row g-3">
            <div class="col-md-6">
                <AppInput
                    name="PolicyHolder.lineNumberCountryCodeId"
                    :label="$root.t('step1.internationalDialingCode')"
                >
                    <AppSelect
                        v-model="form.lineNumberCountryCodeId"
                        :placeholder="$t('common.defaultSelectionValue')"
                        :options="$optionData.countryCodes"
                        searchable
                    />
                </AppInput>
            </div>

            <div class="col-md-6">
                <AppInput
                    name="PolicyHolderDetail.landlineNumber"
                    :label="$root.t('step1.landlineNumber')"
                    rules="phoneNumber"
                >
                    <Input
                        id="PolicyHolder.landlineNumber"
                        v-model="form.landlineNumber"
                        class-name="form-control"
                        auto-complete="tel-national"
                    />
                </AppInput>
            </div>

            <div class="col-md-6">
                <AppInput
                    name="PolicyHolderDetail.countryCodeMobileId"
                    :label="$root.t('step1.internationalDialingCodeList')"
                >
                    <AppSelect
                        v-model="form.countryCodeMobileId"
                        :placeholder="$t('common.defaultSelectionValue')"
                        :options="$optionData.countryCodes"
                        searchable
                    />
                </AppInput>
            </div>

            <div class="col-md-6">
                <AppInput name="PolicyHolder.mobileNumber" :label="$root.t('step1.mobileNumber')" rules="phoneNumber">
                    <Input v-model="form.mobileNumber" class-name="form-control" auto-complete="tel-national" />
                </AppInput>
            </div>

            <div class="col-md-12">
                <AppInput
                    name="PolicyHolder.emailAddress"
                    :label="$root.t('step1.emailAddress')"
                    rules="required|email"
                >
                    <Input v-model="form.emailAddress" class-name="form-control" auto-complete="email" />
                </AppInput>
            </div>
        </div>
    </div>
</template>

<script>
import AppSelect from '../shared/AppSelect.vue'
import Input from '../shared/Input.vue'

export default {
    name: 'ContactDetail',
    components: {
        AppSelect,
        // eslint-disable-next-line vue/no-reserved-component-names
        Input,
    },
    props: {
        msg: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            form: this.$formData.policyHolder.contactDetails,
        }
    },
    mounted() {},
}
</script>
